module.exports = __webpack_public_path__ + "static/media/add_fact_fifth.461291ef.png";